import {
  devAddress,
  makeDevSignature,
  makeDevUpload,
} from "../../components/publicForm/devPrefill";

/**
 * A complete, valid set of answers for the public credit authorization — local
 * dev only (see devPrefill.js).
 *
 * Nearly every field on this form is required, because a bureau match fails on
 * partial identity data — so this is close to the whole form. Only middleName
 * and nameSuffix are genuinely optional, and both are filled anyway since
 * name-matching behavior is one of the things worth testing here.
 *
 * A FUNCTION rather than a constant: the signature is canvas-drawn and the photo
 * ID is a real `File`. Calling it twice yields independent Files, which matters
 * when prefilling again after a submit consumed the first.
 *
 * Kept deliberately consistent with the loan application's dev values (same
 * person, same address, same SSN) so a submission from each can be matched up
 * against the other in the Submissions queue.
 */
export const buildDevCreditAuthValues = () => ({
  firstName: "Dev",
  lastName: "Tester",
  middleName: "Quinn",
  nameSuffix: "Jr.",
  // Bare 10 digits — RffPhoneField stores unformatted and masks for display.
  phone: "5555550123",
  emailAddress: "dev.tester@example.com",
  citizenshipStatus: "US Citizen",
  // Structured, not a formatted line: the credit pull matches streetNumber /
  // streetName / city / state / zip individually.
  primaryAddress: devAddress(),
  // "YYYY-MM-DD", per DOB_VALUE_FORMAT — a full ISO timestamp would shift a day.
  dateOfBirth: "1985-06-15",
  maritalStatus: "Not Married",
  borrowerHasSSN: true,
  // Bare 9 digits, and structurally valid: area is not 000/666/900+, group is
  // not 00, serial is not 0000 — RffSsnField rejects all three.
  borrowerSSN: "123456789",
  // Single `uploadMetadata` array for the whole form; the entry carries its own
  // docGroup/docType, matching what StepCreditAuthIdentification tags uploads with.
  uploadMetadata: [
    makeDevUpload({
      fileName: "dev-photo-id.png",
      docGroup: "Borrower Documents",
      docType: "Photo Identification",
    }),
  ],
  signature: makeDevSignature("Dev Tester"),
});

export default buildDevCreditAuthValues;
